import _linq from 'linq';

if (!_linq) {
  throw new Error("can't find Enumerable. linq.array.js must load after linq.js");
}


_linq.Utils.extendTo(Array);

(window as any)['linq'] = _linq;
(window as any)['Enumerable'] = _linq;

(_linq as any).fromIterator = (iterator: IterableIterator<any>) => {
  return Enumerable.Utils.createEnumerable(() => new IterableIteratorEnumerator(iterator));
}

class IterableIteratorEnumerator<T> implements linqjs.IEnumerator<T> {

  iteration?: IteratorResult<T>;

  constructor(private iterator: IterableIterator<T>) { }

  current(): T {
    return this.iteration!.value;
  }

  moveNext(): boolean {
    this.iteration = this.iterator.next();
    return !this.iteration.done;
  }

  dispose(): void { }
}
